/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon16Regular = forwardRef('ArrowARightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.426 3.608a.75.75 0 1 1 1.061-1.06l3.928 3.927a2.156 2.156 0 0 1 0 3.05l-3.928 3.927a.75.75 0 1 1-1.06-1.06l3.64-3.642H2.716a.75.75 0 0 1 0-1.5h9.353L8.426 3.608Z" })));
});
